import "./slick-banner";
import "./slick-partners";
import "./anchor";